'use strict';

let processInclude = require('./util');

$(document).ready(function () {
  processInclude(require('./product/detail'));
  processInclude(require('./components/giftcard').InitProductDetail);
  processInclude(require('./product/loadMiraklOffers'));
  processInclude(require('./product/miraklQuantityForm'));
  processInclude(require('./product/addOffer'));
});
